import { BrowserBranding } from "./types.ts";
import logoSquareSvg from "../assets/white-label/logo-square.svg";
import loadingSquareAnimation from "../assets/white-label/loading-logo-square.svg";
import logoSquareBitmap from "../assets/white-label/logo.png";
import purposeMyself from "../assets/white-label/get-started/whositfor-myself.png";
import purposeGift from "../assets/white-label/get-started/whosifor-gift.png";
import giftTypeBrickMosaic from "../assets/white-label/get-started/typeofgift-brickmosaic.png";
import giftTypeGiftCard from "../assets/white-label/get-started/typeofgift-giftcard.png";
import giftChooserIChoose from "../assets/white-label/get-started/typeofgift-ichoose.png";
import giftChooserTheyChoose from "../assets/white-label/get-started/typeofgift-theychoose.png";

function createWhiteLabelBrowserBranding(): BrowserBranding {
	return {
		showPoweredBy: true,
		companyName: "Brick My Story",
		domainName: "brickmystory.com",
		logoSquareSvg,
		loadingSquareAnimation,
		logoSquareBitmap,
		giftCardProductPath: "/products/brick-me-gift-card",
		mosaicGiftPagePath: "/pages/mosaic-gift",
		getStartedImages: {
			purposeMyself,
			purposeGift,
			giftTypeBrickMosaic,
			giftTypeGiftCard,
			giftChooserIChoose,
			giftChooserTheyChoose,
		},
	};
}

export { createWhiteLabelBrowserBranding };
